module.exports = __webpack_public_path__ + "static/media/taggis-brochure.008efb35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taggis-brochure.jpg
// module id = 36
// module chunks = 3